<template>
    <!--弹窗-->
    <el-dialog
        width="720px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="170px"
        >
			<el-form-item class="query-form-item acos" >
			    <div class="acosItem">
			        <span style="margin-left: 12px;">Auto-Acos：</span>
			        <el-input-number
			            v-model="formData.auto_acos"
                        size="mini"
			            style="width: 165px;margin-left: 10px;"
			            :min="0.00"
						:max="1"
						:step="0.01"
			            label="请输入auto_acos"
			        ></el-input-number>
			    </div>
				<div class="acosItem">
				    <span>Res-Acos：</span>
				    <el-input-number
				        v-model="formData.res_acos"
				        style="width: 165px;margin-left: 10px;"
						size="mini"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入Res-Acos"
				    ></el-input-number>
				</div>
				<div class="acosItem">
				    <span style="margin-left: 12px;">品牌-Acos：</span>
				    <el-input-number
				        v-model="formData.brand_acos"
				    size="mini"
				        style="width: 165px;margin-left: 10px;"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入品牌-Acos"
				    ></el-input-number>
				</div>
				<div class="acosItem">
				    <span>Asin-Acos：</span>
				    <el-input-number
				        v-model="formData.asin_acos"
				        style="width: 165px;margin-left: 10px;"
				    size="mini"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入Asin-Acos"
				    ></el-input-number>
				</div>
				<div class="acosItem">
				    <span style="margin-left: 12px;">Skag-Acos：</span>
				    <el-input-number
				        v-model="formData.skag_acos"
				    size="mini"
				        style="width: 165px;margin-left: 10px;"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入Skag-Acos"
				    ></el-input-number>
				</div>
				
				<div class="acosItem">
				    <span>Skag-Tos-Acos：</span>
				    <el-input-number
				        v-model="formData.skag_tos_acos"
				        style="width: 165px;margin-left: 10px;"
				    size="mini"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入Skag-Tos-Acos"
				    ></el-input-number>
				</div>
				<div class="acosItem">
				    <span style="margin-left: 12px;">Skag-Ros-Acos：</span>
				    <el-input-number
				        v-model="formData.skag_ros_acos"
				    size="mini"
				        style="width: 165px;margin-left: 10px;"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入Skag-Ros-Acos"
				    ></el-input-number>
				</div>
				
				<div class="acosItem">
				    <span>长尾-Acos：</span>
				    <el-input-number
				        v-model="formData.changwei_acos"
				        style="width: 165px;margin-left: 10px;"
				    size="mini"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入长尾-Acos"
				    ></el-input-number>
				</div>
				<div class="acosItem">
				    <span style="margin-left: 12px;">腰部-Acos：</span>
				    <el-input-number
				        v-model="formData.yaobu_acos"
				    size="mini"
				        style="width: 165px;margin-left: 10px;"
				        :min="0.00"
						:max="1"
						:step="0.01"
				        label="请输入腰部-Acos"
				    ></el-input-number>
				</div>
                <div class="acosItem">
                    <span style="margin-left: 12px;">捡漏-Acos：</span>
                    <el-input-number
                        v-model="formData.jianlou_acos"
                        size="mini"
                        style="width: 165px;margin-left: 10px;"
                        :min="0.00"
                        :max="1"
                        :step="0.01"
                        label="请输入腰部-Acos"
                    ></el-input-number>
                </div>
			</el-form-item>
            <el-form-item label="产品价格：" prop="product_price">
                <el-input
                    v-model="formData.product_price"
                    style="width: 470px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入产品价格"
                >
                    <template slot="prepend">$</template>
                </el-input>
            </el-form-item>
            <el-form-item label="点击数：" prop="clicks">
                <el-input-number
                    v-model="formData.clicks"
                    :min="1"
                    style="width: 470px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入点击数"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="高acos幅度：" prop="tower_acos">
                <el-input
                    v-model="formData.tower_acos"
                    style="width: 470px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入高acos幅度"
                ></el-input>
            </el-form-item>
            <el-form-item label="高点击无出单：" prop="high_click_not_order">
                <el-input
                    v-model="formData.high_click_not_order"
                    style="width: 470px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入高点击无出单"
                ></el-input>
            </el-form-item>
            <el-form-item label="低点击无出单：" prop="low_click_not_order">
                <el-input
                    v-model="formData.low_click_not_order"
                    style="width: 470px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入低点击无出单"
                ></el-input>
            </el-form-item>
            <div class="media-txt">从竞价优化中剔除活动</div>
            <Choice @on-exclude="onArrExclude_activity" />
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import Choice from "./choice";
import * as api from "@/api/statistics/statistics";
export default {
    components: { Choice },
    data() {
        return {
            loading: false,
            textarea: "",
            rules: {
                target_acos: [
                    {
                        required: true,
                        message: "请输入目标ACoS",
                        trigger: "blur"
                    }
                ],
                product_price: [
                    {
                        required: true,
                        message: "请输入产品价格",
                        trigger: "blur"
                    }
                ],
                clicks: [
                    {
                        required: true,
                        message: "请输入点击数",
                        trigger: "blur"
                    }
                ],
                tower_acos: [
                    {
                        required: true,
                        message: "请输入高acos幅度",
                        trigger: "blur"
                    }
                ],
                high_click_not_order: [
                    {
                        required: true,
                        message: "请输入高点击无出单",
                        trigger: "blur"
                    }
                ],
                low_click_not_order: [
                    {
                        required: true,
                        message: "请输入低点击无出单",
                        trigger: "blur"
                    }
                ]
            },
            arrExclude_activity: [],
            formData: {
                clicks: 20,
                tower_acos: 0.9,
                high_click_not_order: 0.8,
                low_click_not_order: 0.95,
				auto_acos: 0,
				res_acos: 0,
				brand_acos: 0,
				asin_acos: 0,
				skag_acos: 0,
				skag_tos_acos: 0,
				skag_ros_acos: 0,
				changwei_acos: 0,
				yaobu_acos: 0,
                jianlou_acos: 0,
            }
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        ad_id: {
            type: Number,
            default: 0
        }
    },
	mounted(){
		this.getData()
	},
    methods: {
		getData() {
			api.get_ad_default_acos({
		        asin: this.$route.query.asin,
		        state: this.$route.query.state
		    })
		        .then(res => {
					for(var x in res.data){
						this.formData[x] = res.data[x];
					}
		        })
		        .finally(() => {
		        });
		},
        typeNumber(str) {
            return Number(Number(str));
            // return Number(Number(str).toFixed(2));
        },
        // 保存信息
        submitForm() {
            this.$refs["formData"].validate(valid => {
                if (valid) {
                    let formData = this.formData;
                    let obj = {
                        ad_id: this.ad_id,
					    auto_acos: this.typeNumber(formData.auto_acos),
						res_acos: this.typeNumber(formData.res_acos),
						brand_acos: this.typeNumber(formData.brand_acos),
						asin_acos: this.typeNumber(formData.asin_acos),
						skag_acos: this.typeNumber(formData.skag_acos),
						skag_tos_acos: this.typeNumber(formData.skag_tos_acos),
						skag_ros_acos: this.typeNumber(formData.skag_ros_acos),
						changwei_acos: this.typeNumber(formData.changwei_acos),
						yaobu_acos: this.typeNumber(formData.yaobu_acos),
                        jianlou_acos: this.typeNumber(formData.jianlou_acos),
                        clicks: formData.clicks,
                        // asin: this.$route.query.asin,
                        // target_acos: this.typeNumber(formData.target_acos),
                        product_price: this.typeNumber(formData.product_price),
                        tower_acos: this.typeNumber(formData.tower_acos),
                        high_click_not_order: this.typeNumber(
                            formData.high_click_not_order
                        ),
                        low_click_not_order: this.typeNumber(
                            formData.low_click_not_order
                        ),
                        exclude_activity: this.arrExclude_activity.join(",")
                    };
                    this.loading = true;
                    // return
                    api.reduce_bid_add(obj)
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.$emit("refresh");
                                this.handleClose(false);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message: "网络出现问题，请刷新页面！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        onArrExclude_activity(arr) {
            this.arrExclude_activity = arr;
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.formData = {
                clicks: 20,
                tower_acos: 0.9,
                high_click_not_order: 0.8,
                low_click_not_order: 0.95
            };
			this.getData();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
	.acos{
		margin-left: -155px;
		.acosItem{
			float: left;
			width:320px;
			text-align: right;
		}
	}
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;
	
    .shu {
        border-right: 1px solid #cecfd1;
    }
    .content-div {
        width: 50%;
        padding: 25px 20px;
    }
    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }
    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }
    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;
        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }
    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
